<template>
	<div class="ts-h-1/4 ts-overflow-y-scroll">
		<h3 class="ts-text-xs ts-uppercase ts-text-blue-700">{{ $t('productProfile.vendorList') }}</h3>
		<div class="ts-pl-8 ts-space-y-2">
      <a-select
        class="ts-w-full"
        mode="multiple"
        v-model="model.vendor_list"
        :options="vendorList"
        :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
        :maxTagCount="4"
      ></a-select>
		</div>
	</div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'vendorList',
  props: ['value', 'validate', 'full'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
	},
	computed:{
    vendorList(){
      return this.$store.state.product.profile.vendors.map(el => ({
        value: el.vendor_id,
        label: el.vendor_name
      }))
    }
	},
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>